export const RELEASE_NOTE_POPUP_DISMISSED_KEY = 'releaseNotePopupDismissed';
